/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для подарка в корзине
   */
  app.CartGiftView = app.ItemView.extend({
    beforeRun: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#cart_gift_item');
    },
    render: function (element) {
      if (!element) {
        var item = this.model.item;
        element = this.template({
          model: item.toJSON(),
          itemUrl: item.getUrl(),
          itemPhoto140: item.getPhotoUrl(),
          itemPhoto400: item.getPhotoUrl(undefined, 400),
          giftUrl: this.model.getUrl(),
          giftMinSum: this.model.get('min_sum'),
          giftMinQty: this.model.get('min_qty'),
          qty: this.model.get('qty'),
          country: this.model.get('country'),
          trademark: this.model.get('trademark'),
          format: app.helpers.DeclinationHelper.format,
          isRemoteStoreWithTooltip: this.model.get('is_small_wholesale_available'),
        });
      }
      this.setElement(element);
      this.initDom();
      return this;
    },
    initDom: function () {
      this.favWtfId = this.model.get('item').id;
      if (this.model.get('wishItem') && _.isObject(this.model.get('wishItem'))) {
        app.wish.add(new app.WishItem(this.model.get('wishItem')));
      }
      app.ItemView.prototype.initDom.apply(this, []);
    },
  });
})();

}.call(window));